import axios from "axios";
import AddProduct from "components/Modal/AddProduct";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Swal from "sweetalert2";

// components

export default function CardEditOrder() {
  const [datas, setDatas] = useState({ shippingCost: 0, vat: 0, status: "Opened" });
  const [items, setItems] = useState([]);
  const [sales, setSales] = useState("");
  const [exist, setExist] = useState("");
  const [checkPass, setCheckPass] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [sumPrice, setSumPrice] = useState(0);
  const { ordersCode } = useParams();
  const [units, setUnits] = useState("");
  const [products, setProducts] = useState("");
  const [history, setHistory] = useState("");
  useEffect(() => {


    axios.get(`http://${process.env.REACT_APP_API_URL}/users/search-all`, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      // console.log(response);
      if (response.status === 200) {
        setSales(response.data);

      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
      // console.log(error.response.data.message);
    });

    axios.get(`http://${process.env.REACT_APP_API_URL}/utility/search-unit`, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      // console.log(response);
      if (response.status === 200) {
        setUnits(response.data);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
      // console.log(error.response.data.message);
    });

    axios.get(`http://${process.env.REACT_APP_API_URL}/products/search-All`, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      // console.log(response);
      if (response.status === 200) {
        setProducts(response.data);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
      // console.log(error.response.data.message);
    });

   

  }, [])

  useEffect(() => {
    axios.post(`http://${process.env.REACT_APP_API_URL}/orders/search`, { ordersCode: ordersCode }, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      if (response.status === 200) {
        delete response.data.password;
        setDatas(response.data?.orders);
        setItems(response.data?.ordersItems);
        setHistory(response.data?.history);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
    });

  }, [ordersCode])



  useEffect(() => {
    let sum = 0
    items.map(item => {
      sum += (item.pricePerUnit - item.discountPerUnit) * item.qty
    })
    setSumPrice(sum)
    let productQty = 0
    items.map(item => {
      productQty += item.qty
    }
    )
    setDatas({ ...datas, productQty: productQty })

    setDatas({ ...datas, items: items })
  }, [items])

  const handleQty = (e, code, qtyWH) => {
    if (Number(e.target.value) <= -1) {
      e.target.value = 0
    }
    if (Number(e.target.value) > qtyWH) {
      e.target.value = qtyWH
    }
    const exist = items.find(item => item.productCode === code)
    if (exist) {
      setItems(items.map(item => item.productCode === code ? { ...item, qty: (Number(e.target.value) > item.quantityWH) ? item.quantityWH : Number(e.target.value) } : item))
    }
  }

  const handleDiscount = (e, code, pricePerUnit) => {
    if (Number(e.target.value) < 0) {
      e.target.value = 0
    }
    if (Number(e.target.value) > pricePerUnit) {
      e.target.value = pricePerUnit
    }
    const exist = items.find(item => item.productCode === code)
    if (exist) {
      setItems(items.map(item => item.productCode === code ? { ...item, discountPerUnit: Number(e.target.value) } : item))
    }
  }

  const handleData = (e) => {
    setDatas({ ...datas, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    axios.post(`http://${process.env.REACT_APP_API_URL}/orders/save`, datas, {
      headers: {
        Bearer: localStorage.getItem('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      console.log(response);
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Success!',
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          window.location.href = "/order";
        }
        )
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      // console.log(error.response.data.message);
      Swal.fire({
        icon: 'error',
        text: error.response.data.message,
      })
    });
  };

  const handleDelete = (e, code) => {
    const exist = items.find(x => x.productCode === code)
    if (exist) {
      setItems(items.filter(item => item.productCode != code));
    }
  }

  const handleImg = (e) => {
    //tobase64
    const file = e.target.files[0];
    // check hieght and width
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        console.log(reader);
        const base64String = reader.result.split(',')[1];
        setDatas({ ...datas, paymentSlip: base64String })
      };
      reader.onerror = () => {
        console.error('AHHHHHHHH!!');
      };
    } else {
      setDatas({ ...datas, image: "" })
    }

  }
 
  useEffect(() => {
  if (products && datas?.items?.length > 0) {
    datas.items.map(item => {
      const product = products?.find(x => x.productCode === item.productCode)
      if (product) {
        item.quantityWH = product.qty+item.qty
      }
    })
  }
  }, [products])

  return (

    <>
      {(!datas || !products) ? <div>
        <p className="text-3xl font-bold semibold text-blueGray-700">
          Loading
        </p>
      </div>
        :
        <div className="relative flex flex-col w-full h-full min-w-0 p-5 mb-6 break-words bg-white rounded shadow-lg" style={{ borderRadius: "20px" }}>
          <div className="px-4 py-3 mb-0 border-0 rounded">
            <div className="flex flex-wrap items-center">
              <div className="relative flex-1 flex-grow w-full max-w-full mb-2">
                <h1 className="text-3xl font-bold semibold text-blueGray-700">
                  Update Order
                </h1>
              </div>
            </div>
          </div>
          <div className="block w-full mb-1 overflow-x-auto ">
            {/* Projects table */}
            <form onSubmit={(e) => { handleSubmit(e) }}>
              <div className="grid mb-6 -mx-3">
                <div className="flex">
                  {/* <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    วันที่เบิกสินค้า
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="productCode" name="productCode" type="date" onChange={handleData} defaultValue={new Date().toISOString("en").split("T")[0]} />
                </div> */}

                </div>

                <div className="flex">
                  <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      หมายเลขติดตาม
                    </label>
                    <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                      id="trackingNumber" name="trackingNumber" type="text" onChange={handleData} value={datas.trackingNumber} />
                    {/* {!datas.trackingNumber && <p className="text-xs italic text-red-500">โปรดกรอก หมายเลขติดตาม</p>} */}
                  </div>
                  <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      วันที่ได้รับ
                    </label>
                    <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                      id="receivedDate" name="receivedDate" type="date" onChange={handleData} value={datas.receivedDate} />
                  </div>
                  <div className="px-3 mb-3 md:mb-0 " style={{ width: "300px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      ช่องทางการจัดส่ง
                    </label>
                    <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                      id="deliveryChannel" name="deliveryChannel" type="text" onChange={handleData} value={datas.deliveryChannel} />
                    {!datas.deliveryChannel && <p className="mt-3 text-xs italic text-red-500">โปรดเลือก ช่องทางการจัดส่ง </p>}
                  </div>
                  <div className="px-3 mb-3 md:mb-0 " style={{ width: "300px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      ค่าขนส่ง
                    </label>
                    <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                      id="shippingCost" name="shippingCost" type="text" onChange={handleData} value={datas.shippingCost} />
                  </div>
                </div>

                <div className="flex justify-between">
                  <div className="px-3 mb-3 md:mb-0 " >
                    <label className="mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase " >
                      รายการสินค้า
                    </label>

                  </div>
                  <div className="px-3 mb-3 md:mb-0 " >

                    <button
                      className={"px-3 py-3 m-1 mr-1 text-xs font-bold text-white uppercase transition-all duration-150 ease-linear bg-indigo-500 rounded outline-none active:bg-indigo-600 focus:outline-none"}
                      type="button"
                      onClick={() => setShowModal(true)}
                    >
                      Add Product
                    </button>
                  </div>
                </div>

                <div >
                  <table className="w-full text-center table-order-products ">
                    <thead >
                      <tr>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">#</th>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">รหัสสินค้า</th>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">ชื่อสินค้า</th>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">จำนวน</th>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">ราคาต่อหน่วย</th>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">หน่วย</th>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">ส่วนลดต่อหน่วย</th>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">ราคารวม</th>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">จัดการ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items && items.map((data, index) => {
                        return (
                          <tr key={index}>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{index + 1}</td>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.productCode}</td>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{products && products?.find(x => x.productCode === data.productCode).productName}</td>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell"><input onChange={(e) => handleQty(e, data.productCode, data.quantityWH)} style={{ width: "80px" }} type="number" min={1}  defaultValue={data.qty} max={data.quantityWH}></input></td>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.pricePerUnit}</td>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{(units && products) && units?.find(x => x.id == products?.find(x => x.productCode === data.productCode)?.unit)?.unitName}</td>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell"><input onChange={(e) => handleDiscount(e, data.productCode, data.pricePerUnit)} style={{ width: "80px" }} type="number" min={0} max={data.pricePerUnit} value={data.discountPerUnit}></input></td>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{(data.pricePerUnit - data.discountPerUnit) * data.qty}</td>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">
                              <button
                                className={"px-3 py-3 m-1 mr-1 text-xs font-bold text-white uppercase transition-all duration-150 ease-linear bg-red-500 rounded outline-none active:bg-red-600 focus:outline-none"}
                                type="button"
                                onClick={(e) => handleDelete(e, data.productCode)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        )
                      }
                      )}
                    </tbody>
                  </table>

                </div>

                <div className="flex justify-end">
                  <div className="mb-3 md:mb-0" style={{ width: "200px", paddingTop: "30px" }} >
                    <p className="mb-2 font-bold tracking-wide text-gray-700 uppercase text-md " >
                      ส่วนลด :
                    </p>
                  </div>
                  <div className="mb-3 text-right md:mb-0" style={{ width: "200px", padding: "30px 30px 0 0" }} >
                    <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                      id="discount" name="discount" type="number" onChange={handleData} value={datas.discount} />
                  </div>
                </div>
                <div className="flex justify-end">
                  <div className="mb-3 md:mb-0" style={{ width: "200px", paddingTop: "30px" }} >
                    <p className="mb-2 font-bold tracking-wide text-gray-700 uppercase text-md " >
                      มูลค่าก่อนรวมภาษี :
                    </p>
                  </div>
                  <div className="mb-3 text-right md:mb-0" style={{ width: "200px", padding: "30px 30px 0 0" }} >
                    <p className="mb-2 font-bold tracking-wide text-gray-700 uppercase text-md " >
                    {(sumPrice - datas.discount).toFixed(2)}
                    </p>
                  </div>
                </div>
                <div className="flex justify-end">
                  <div className="mb-3 md:mb-0" style={{ width: "200px", }} >
                    <p className="mb-2 font-bold tracking-wide text-gray-700 uppercase text-md " >
                      ค่าขนส่ง :
                    </p>
                  </div>
                  <div className="mb-3 text-right md:mb-0" style={{ width: "200px", paddingRight: "30px" }} >
                    <p className="mb-2 font-bold tracking-wide text-gray-700 uppercase text-md " >
                      {((Number(datas?.shippingCost).toFixed(2)) ?? 0.00)}
                    </p>
                  </div>
                </div>
                <div className="flex justify-end">
                <div className="mb-3 md:mb-0" style={{ width: "200px", }} >
                  <p className="mb-2 font-bold tracking-wide text-gray-700 uppercase text-md " >
                    ภาษีมูลค่าเพิ่ม % :
                  </p>
                </div>
                <div className="mb-3 text-right md:mb-0" style={{ width: "200px", paddingRight: "30px" }} >
                  <p className="mb-2 font-bold tracking-wide text-gray-700 uppercase text-md " >
                    {Number(((sumPrice - datas.discount) + Number(datas?.shippingCost)) * (Number(datas?.vat) / 100)).toFixed(2) ?? 0.00}
                  </p>
                </div>
              </div>
              <div className="flex justify-end">
                <div className="mb-3 md:mb-0" style={{ width: "200px", }} >
                  <p className="mb-2 text-xl font-bold tracking-wide text-gray-700 uppercase " >
                    มูลค่ารวมสุทธิ :
                  </p>
                </div>
                <div className="mb-3 text-right md:mb-0" style={{ width: "200px", paddingRight: "30px" }} >
                  <p className="mb-2 text-xl font-bold tracking-wide text-gray-700 uppercase " >
                    {Number((sumPrice - datas.discount + Number(datas?.shippingCost)) * (Number(datas?.vat) / 100) + Number((sumPrice - datas.discount + Number(datas?.shippingCost)))).toFixed(2)}
                  </p>
                </div>
              </div>

                <div className="flex">
                  <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      ตัวแทนขาย
                    </label>
                    <select name="sales" id="sales" className="rounded" onChange={handleData} value={datas.sales} style={{ width: "275px", height: "50px" }} >
                      <option value="" disabled selected>Choose</option>
                      {
                        sales && sales.map((data, index) => {
                          return (
                            <option key={index} value={data.username}>{data.username}</option>
                          )
                        }
                        )
                      }
                    </select>
                    {!datas.sales && <p className="mt-3 text-xs italic text-red-500">โปรดเลือก ตัวแทนขาย</p>}
                  </div>
                  <div className="px-3 mb-3 md:mb-0 " style={{ width: "300px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      วิธีการชำระเงิน
                    </label>
                    <select name="paymentMethod" id="paymentMethod" className="rounded" onChange={handleData} value={datas.paymentMethod} style={{ width: "275px", height: "50px" }} >
                      <option value="" disabled selected>Choose</option>
                      <option value="โอนเงิน" >โอนเงิน</option>
                      <option value="เงินสด" >เงินสด</option>
                      <option value="เก็บปลายทาง" >เก็บปลายทาง COD</option>
                    </select>
                    {!datas.paymentMethod && <p className="mt-3 text-xs italic text-red-500">โปรดเลือก วิธีการชำระเงิน </p>}
                  </div>
                  <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      ภาษีมูลค่าเพิ่ม %
                    </label>
                    <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                      id="vat" name="vat" type="text" onChange={handleData} value={datas.vat} />
                  </div>
                </div>
                <div className="flex">
                  <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      ชื่อลูกค้า
                    </label>
                    <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                      id="customer" name="customer" type="text" onChange={handleData} value={datas.customer} />
                    {!datas.customer && <p className="text-xs italic text-red-500">โปรดกรอก ชื่อลูกค้า</p>}
                  </div>
                  <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      เบอร์โทรศัพท์
                    </label>
                    <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                      id="tel" name="tel" type="text" onChange={handleData} value={datas.tel} />
                    {!datas.tel && <p className="text-xs italic text-red-500">โปรดกรอก เบอร์โทรศัพท์</p>}
                  </div>
                  <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      โซเชียล
                    </label>
                    <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                      id="social" name="social" type="text" onChange={handleData} value={datas.social} />
                    {!datas.social && <p className="text-xs italic text-red-500">โปรดกรอก โซเชียล</p>}
                  </div>
                </div>
                <div className="flex">
                  <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "600px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      ที่อยู่
                    </label>
                    <textarea className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                      id="address" name="address" onChange={handleData} value={datas.address} />
                    {!datas.address && <p className="text-xs italic text-red-500">โปรดกรอก ที่อยู่</p>}
                  </div>
                  <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      PaymentSlip
                    </label>
                    <input style={{}}
                      className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-500 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                      id="paymentSlip" name="paymentSlip" type="file" onChange={handleImg} accept="image/*" max={100} />
                  </div>
                  {datas.paymentSlip && <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      Preview image
                    </label>
                    <img src={`data:image/jpeg;base64,${datas.paymentSlip}`} style={{ width: "200px", height: "200px" }} />
                  </div>}

                </div>
                <div className="flex">
                  <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "600px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      หมายเหตุ
                    </label>
                    <textarea className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                      id="note" name="note" onChange={handleData} value={datas.note} />
                  </div>
                  <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "600px" }}>
                    <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                      ข้อมูลการนำส่ง
                    </label>
                    <textarea className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                      id="deliveryInformation" name="deliveryInformation" onChange={handleData} value={datas.deliveryInformation} />
                  </div>


                </div>
                <div className="w-full px-3 mb-3 md:mb-0">
                  <button
                    className={"px-3 py-3 m-1 mr-1 text-xs font-bold text-white uppercase transition-all duration-150 ease-linear bg-indigo-500 rounded outline-none active:bg-indigo-600 focus:outline-none"}
                    type="submit"
                    disabled={items.length === 0 || !datas.sales || !datas.paymentMethod || !datas.customer || !datas.tel || !datas.social || !datas.address || !datas.deliveryChannel}
                    style={{ backgroundColor: items.length === 0 || !datas.sales || !datas.paymentMethod || !datas.customer || !datas.tel || !datas.social || !datas.address || !datas.deliveryChannel ? "#9CA3AF" : "#60A5FA" }}
                  >
                    Update Order
                  </button>
                </div>
                {/* } */}
                <div className="mt-3 ">
                  <label className="mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase " >History</label>
                  <table className="text-center table-order-products">
                    <thead >
                      <tr>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">#</th>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">วันที่</th>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">สถานะ</th>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">ผู้ดำเนินการ</th>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">Vat</th>
                        <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">ยอดสุทธิ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {history && history.map((data, index) => {
                        return (
                          <tr key={index}>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{index + 1}</td>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{new Date(data.updateDate).toLocaleDateString("en")}</td>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.status}</td>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.updateBy}</td>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.vat}</td>
                            <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.net}</td>
                          </tr>
                        )
                      }
                      )}
                    </tbody>
                  </table>


                </div>
              </div>
            </form>

          </div>
          {showModal && <AddProduct showModal={showModal} setShowModal={setShowModal} setItems={setItems} items={items} />}
        </div>
      }
    </>
  );
}
